import { loginRequest } from '../authConfig';

/**
 * Retrieves a valid access token, silently refreshing it if necessary.
 * Falls back to an interactive popup if silent refresh fails.
 *
 * @param {object} msalInstance - The initialized MSAL instance
 * @param {object} account - The active user account
 * @returns {Promise<string>} The valid access token
 */
export const getValidToken = async (msalInstance, account) => {
  if (typeof msalInstance.initialize === 'function') {
    await msalInstance.initialize();
  }
  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response.accessToken;
  } catch (error) {
    console.warn('Silent token fetch failed, attempting interactive login popup...', error);
    const response = await msalInstance.acquireTokenPopup({
      ...loginRequest,
      account,
    });
    return response.accessToken;
  }
};